export default {
  // 页面标题
  'dashboard.title': '运营控制台',
  'dashboard.subtitle': '这里提供了各种产品同步、库存管理、订单处理等操作的配置和执行功能。',
  
  // 统计卡片
  'dashboard.stats.categories': '分类',
  'dashboard.stats.tasks': '任务总数',
  'dashboard.stats.running': '运行中',
  'dashboard.stats.completed': '已完成',
  
  // 分类名称
  'dashboard.category.product': '产品管理',
  'dashboard.category.order': '订单管理',
  'dashboard.category.dear': 'DEAR数据跟踪',
  'dashboard.category.others': '其他',
  'dashboard.common.operations': '常用操作',
  
  // 任务名称
  'dashboard.task.product.status.check': '检查产品状态',
  'dashboard.task.product.sync': '产品同步',
  'dashboard.task.product.price.sync': '价格同步',
  'dashboard.task.product.stock': '库存同步',
  'dashboard.task.product.image': '图片同步',
  'dashboard.task.product.grouping.sync': '分组同步',
  'dashboard.task.product.duplicate.check': '检查重复产品',
  'dashboard.task.product.unpublish': '下架无效产品',
  'dashboard.task.product.clean.unbound': '清理未绑定产品',
  'dashboard.task.product.delete': '删除产品变体',
  'dashboard.task.product.backup': '备份产品',
  'dashboard.task.product.dear.manual.sync': '手动DEAR同步',
  'dashboard.task.product.dear.unpublish.check': '手动下架检查',
  'dashboard.task.product.dear.sync.barcode': '指定条码同步',
  'dashboard.task.product.dear.backfeed': 'DEAR回传同步',
  'dashboard.task.product.media.check': '媒体文件检查',
  'dashboard.task.product.sync.hscode': '同步HS编码',
  'dashboard.task.product.merge.reviews': '合并评论',
  'dashboard.task.product.cloudinary.task': '图片同步任务',
  'dashboard.task.order.sync': '订单同步',
  'dashboard.task.order.status.check': '检查订单状态',
  'dashboard.task.order.push': '推送订单到DEAR',
  'dashboard.product.sync.progress.title': '产品同步进行中',
  'dashboard.async.task.progress.title': '后台任务进行中',
  'dashboard.async.progress.phase.media': '媒体同步',
  'dashboard.async.progress.phase.grouping': 'Grouping 同步',
  'dashboard.async.progress.phase.stock': '库存同步',
  'dashboard.async.progress.phase.status_check': '状态检查',
  'dashboard.async.progress.phase.unpublish': '下架检查',
  'dashboard.async.progress.phase.cleanup': '清理未绑定',
  'dashboard.async.progress.phase.duplicate_check': '重复产品检查',
  'dashboard.async.progress.phase.sync': '同步',
  'dashboard.image.sync.progress.phase.media': '媒体同步',
  'dashboard.image.sync.progress.phase.grouping': 'Grouping 同步',
  'dashboard.product.sync.progress.total': '总数',
  'dashboard.product.sync.progress.processed': '已处理',
  'dashboard.product.sync.progress.succeeded': '成功',
  'dashboard.product.sync.progress.failed': '失败',
  'dashboard.product.sync.duplicate': '已有相同任务在运行，返回现有进度',
  'dashboard.product.sync.cancel.sent': '已发送取消请求，同步将在当前步骤结束后停止',
  'dashboard.product.sync.cancel.failed': '取消任务失败',
  'dashboard.task.order.migration': 'Shopify 订单迁移导入',
  
  // 任务描述
  'dashboard.desc.product.status.check': '检查产品是否满足上架条件（DEAR状态、图片、价格等），并根据检查结果自动处理上架或下架。支持批量处理和指定产品，可选是否包含测试产品，支持强制重新检查已下架产品。',
  'dashboard.desc.product.sync': '从DEAR同步产品信息到Shopify，支持智能和强制模式',
  'dashboard.desc.product.price.sync': '同步产品价格到Shopify，支持智能和强制模式',
  'dashboard.desc.product.stock': '同步产品库存到Shopify，支持指定条码或全量同步',
  'dashboard.desc.product.image': '同步产品图片到Shopify，支持智能和强制模式',
  'dashboard.desc.product.grouping.sync': '更新产品变体分组关系',
  'dashboard.desc.product.duplicate.check': '检查并处理重复产品',
  'dashboard.desc.product.unpublish': '自动下架不符合要求的产品',
  'dashboard.desc.product.clean.unbound': '清理未在索引表中的产品',
  'dashboard.desc.product.delete': '删除指定的产品变体',
  'dashboard.desc.product.backup': '备份产品数据',
  'dashboard.desc.product.dear.manual.sync': '立即执行一次DEAR数据同步',
  'dashboard.desc.product.dear.unpublish.check': '立即执行一次自动下架检查',
  'dashboard.desc.product.dear.sync.barcode': '同步指定条码的产品数据',
  'dashboard.desc.product.dear.backfeed': '从Shopify同步状态到DEAR，更新HSCode',
  'dashboard.desc.product.media.check': '检查和验证产品媒体文件',
  'dashboard.desc.product.sync.hscode': '为所有产品同步HS编码数据',
  'dashboard.desc.product.merge.reviews': '合并和整合产品评论',
  'dashboard.desc.product.cloudinary.task': '执行产品图片同步任务（GDrive → Shopify CDN）',
  'dashboard.desc.order.sync': '在系统间同步订单',
  'dashboard.desc.order.status.check': '检查并更新订单状态',
  'dashboard.desc.order.push': '将指定订单从Shopify推送到DEAR系统。',
  'dashboard.desc.order.migration': '上传 DEAR「Shopify Order Migration」导出的 xlsx（第一列为 SaleID）。将依次执行：① DEAR 客户同步到 Shopify（近 30 天有变更）② 按 SaleID 逐个抓取 DEAR 订单详情 ③ 同步订单到 Shopify。建议首次使用试运行模式。',
  'dashboard.order.migration.upload': '点击或拖拽 xlsx 文件到此处',
  'dashboard.order.migration.upload.hint': '格式与邮件附件「Query for Shopify Order Migration」一致，首列 SaleID',
  'dashboard.order.migration.execute': '解析并执行迁移',
  'dashboard.order.migration.selectFile': '请先选择 xlsx 文件',
  'dashboard.order.migration.success.async': '已解析 {count} 个 SaleID，迁移任务已在后台启动。可在下方查看进度，完成后将发送结果邮件。',
  'dashboard.order.migration.success.async.dryRun': '已解析 {count} 个 SaleID，迁移任务已在后台启动（试运行）。可在下方查看进度，完成后将发送结果邮件。',
  'dashboard.order.migration.progress.title': '迁移进度',
  'dashboard.order.migration.progress.taskId': '任务 ID',
  'dashboard.order.migration.progress.phase': '当前阶段',
  'dashboard.order.migration.progress.status': '状态',
  'dashboard.order.migration.progress.polling': '刷新中…',
  'dashboard.order.migration.progress.done': '迁移已完成',
  'dashboard.order.migration.progress.failed': '迁移失败',
  'dashboard.order.migration.progress.partial': '已完成（存在错误）',
  'dashboard.order.migration.col.saleId': 'SaleID',
  'dashboard.order.migration.col.orderNumber': '订单号',
  'dashboard.order.migration.col.itemStatus': '状态',
  'dashboard.order.migration.col.message': '说明',
  'dashboard.order.migration.phase.pending': '等待中',
  'dashboard.order.migration.phase.customer_sync': '同步客户',
  'dashboard.order.migration.phase.order_sync': '同步订单',
  'dashboard.order.migration.phase.done': '已完成',
  'dashboard.order.migration.item.pending': '等待中',
  'dashboard.order.migration.item.success': '成功',
  'dashboard.order.migration.item.dry_run': '试运行通过',
  'dashboard.order.migration.item.skipped': '已跳过',
  'dashboard.order.migration.item.failed': '失败',
  'dashboard.order.migration.item.fetch_failed': '拉取失败',
  'dashboard.order.migration.item.not_found': '未处理',
  'dashboard.order.migration.success.sync': '已完成 {count} 个 SaleID 的完整迁移（客户同步 + 订单抓取 + Shopify 同步）',
  'dashboard.order.migration.success.sync.dryRun': '已完成 {count} 个 SaleID 的完整迁移（客户同步 + 订单抓取 + Shopify 同步）（试运行）',
  
  // 按钮和操作
  'dashboard.button.configure': '配置并执行',
  'dashboard.button.execute': '执行任务',
  'dashboard.button.cancel': '取消',
  'dashboard.button.confirm': '确定',
  
  // 任务状态
  'dashboard.status.running': '运行中',
  'dashboard.status.success': '成功',
  'dashboard.status.failed': '失败',
  'dashboard.status.not.executed': '未执行',
  
  // 表单标签
  'dashboard.form.barcode': '产品条码',
  'dashboard.form.barcode.placeholder': '支持多种分隔方式：\n1001,1002,1003\n1001 1002 1003\n1001\n1002\n1003',
  'dashboard.form.barcode.extra': '可选：指定产品条码，多个可用逗号、空格或换行分隔，留空处理所有产品',
  'dashboard.form.order.id': '订单ID',
  'dashboard.form.order.id.placeholder': '输入订单ID',
  'dashboard.form.order.id.extra': '可选：指定特定订单ID',
  'dashboard.form.order.shopify_id': 'Shopify 订单ID',
  'dashboard.form.order.shopify_id.placeholder': '输入 Shopify 订单的数字ID，如 6506702471393',
  'dashboard.form.order.shopify_id.extra': '必填：Shopify 订单的数字ID',
  'dashboard.form.order.shopify_id.required': '请输入 Shopify 订单ID',
  'dashboard.form.order.shopify_number': 'Shopify 订单号',
  'dashboard.form.order.shopify_number.placeholder': '可选，如 #1234',
  'dashboard.form.order.shopify_number.extra': '可选：方便识别的 Shopify 订单号',
  'dashboard.form.force.recheck': '强制重新检查已下架产品',
  'dashboard.form.include.test': '包含测试产品',
  'dashboard.form.auto.execute': '自动执行更新',
  'dashboard.form.auto.execute.desc': '检查后自动执行状态变更',
  'dashboard.form.performance.mode': '性能模式',
  'dashboard.form.performance.mode.extra': '选择执行模式',
  'dashboard.form.performance.ultra.fast': '超快模式',
  'dashboard.form.performance.detailed': '详细模式',
  'dashboard.form.force.reupload': '强制重新上传所有图片',
  'dashboard.form.image.sync.scope': '同步范围',
  'dashboard.form.image.sync.main': '主图 (Main Images)',
  'dashboard.form.image.sync.reference': 'Reference Media',
  'dashboard.form.image.sync.assembly': 'Assembly Manual (PDF)',
  'dashboard.form.image.sync.grouping': 'Grouping',
  'dashboard.form.image.sync.scope.required': '请至少选择一项同步内容',
  'dashboard.form.sync.mode': '同步模式',
  'dashboard.form.sync.mode.extra': '选择同步模式',
  'dashboard.form.sync.mode.smart': '智能模式',
  'dashboard.form.sync.mode.force': '强制模式',
  'dashboard.form.enable.image.sync': '启用图片同步',
  'dashboard.form.concurrent': '并发执行',
  'dashboard.form.concurrent.desc': '提高执行速度',
  'dashboard.form.dry.run': '试运行模式',
  'dashboard.form.dry.run.desc': '启用后，仅显示将要执行的操作而不实际修改数据。建议首次执行时启用。',
  
  // 确认对话框
  'dashboard.confirm.title': '确认执行',
  'dashboard.confirm.content': '您即将执行',
  'dashboard.confirm.warning': '警告：这将执行真实操作并可能修改数据！',
  'dashboard.confirm.question': '您确定要继续吗？',
  
  // 消息提示
  'dashboard.message.success': '执行成功',
  'dashboard.message.failed': '执行失败',
  'dashboard.message.fetch.failed': '获取任务列表失败',
  'dashboard.message.loading': '加载任务列表...',
  'dashboard.message.permission.denied': '权限不足，无法执行此操作',
  
  // 执行结果
  'dashboard.results.title': '最近执行结果',
  'dashboard.results.status': '状态',
  'dashboard.results.success.flag': '✅ 成功',
  'dashboard.results.failed.flag': '❌ 失败',
  'dashboard.results.result': '结果',
  'dashboard.results.error': '错误',
  
  // 模态框
  'dashboard.modal.title': '配置任务',
  'dashboard.modal.execution.options': '执行选项',
};